import { Redirect } from "react-router-dom"
import styled, { css } from "styled-components"

import { breakpoint, colors } from "@minuthq/meatball-ui-react"
import { useMediaQuery } from "usehooks-ts"

import { ScrollArea } from "src/components/ScrollArea/ScrollArea"
import { useBackendFlags } from "src/data/flags/useBackendFlags"
import { useOrganization } from "src/data/organizations/hooks/useOrganization"
import { Routes } from "src/router/routes"

import { GuestConversation } from "./GuestConversations/GuestConversation"
import { GuestConversationsList } from "./GuestConversations/GuestConversationsList"

export function GuestInbox({ guestId }: { guestId?: string }) {
  const { compass_released } = useBackendFlags()

  const { org } = useOrganization()

  const isMediumDown = useMediaQuery(`(${breakpoint.mediumDown})`)

  if (!compass_released) {
    return <Redirect to={Routes.Dashboard.location().pathname} />
  }

  if (isMediumDown && !guestId) {
    return (
      <StyledScrollArea hideBorder>
        <GuestConversationsList />
      </StyledScrollArea>
    )
  }

  if (isMediumDown && guestId) {
    return (
      <MobileContainer>
        <GuestConversation orgId={org.id} guestId={guestId} showBackButton />
      </MobileContainer>
    )
  }

  return (
    <Container>
      <StyledScrollArea>
        <GuestConversationsList initilizeToFirstConversation={!guestId} />
      </StyledScrollArea>

      <ScrollArea>
        {guestId && <GuestConversation orgId={org.id} guestId={guestId} />}
      </ScrollArea>
    </Container>
  )
}

const screenHeight = css`
  height: 100vh;
  overflow: hidden;
`

const Container = styled.div`
  display: grid;
  grid-template-columns: minmax(200px, 300px) 1fr;
  ${screenHeight}
`

const MobileContainer = styled.div`
  ${screenHeight}
`

const StyledScrollArea = styled(ScrollArea)<{ hideBorder?: boolean }>`
  border-right: ${({ hideBorder }) =>
    hideBorder ? "none" : `1px solid ${colors.divider}`};
`
